import React from "react";
//Image... 
import Mechanic from '../images/Mechanic.jpg'

export const About = () => {
    return (
        <section className='about-section' id='about'>
            <div className='section-content'>

                <div className='about-details'>
                    <h2 className='section-title'>
                        About Us
                    </h2>

                    <p className='about-text'>
                        We provide a wide range of mobile mechanic services to keep your vehicle running at its best. From radiator replacements, water pumps, and alternators to brakes, suspension, steering, and AC system repairs, our technicians handle it all on-site. We also offer advanced diagnostics, tune-ups, fuel and power steering system repairs, pre-purchase vehicle inspections, towing, and car key programming delivering fast, reliable service wherever you are.
                    </p>

                    <div className='about-stats'>
                        <div className='about-stat-card'>
                            <p className='about-stat-number'>20+</p>
                            <p className='about-stat-label'>Happy Clients</p>
                        </div>

                        <div className='about-stat-card'>
                            <p className='about-stat-number'>5+</p>
                            <p className='about-stat-label'>Years Experience</p>
                        </div>
                    </div>
                </div>

                <div className='about-image-wrapper'>
                    <img src={Mechanic} alt='Automotive locksmith service' className='about-image'/>
                </div>
            </div>
        </section>
    )
}
